import { emptyString } from "../../../constants";

export const mergeDuplicateStoresConstants = {
  GET_MERGE_DUBLICATE_STORE_LOGS: "GET_MERGE_DUBLICATE_STORE_LOGS",
  MERGE_DUBLICATE_STORES: "MERGE_DUBLICATE_STORES",
};

export const mergeStoreFilterOptions = [
  { id: 1, label: "All", value: emptyString },
  { id: 2, label: "Completed", value: "Completed" },
  { id: 3, label: "Pending", value: "Pending" },
  { id: 4, label: "Failed", value: "Failed" },
];


export const statusColors = {
  "Completed": 'success', // Completed
  "Pending": 'warning',   // Pending
  "Failed": 'danger'      // Failed
};